import VehiclesError from './VehiclesError.js'

export default class GetVersionInfoVehiclesError extends VehiclesError {}
